import { createFileRoute } from "@tanstack/react-router";

import { Onboarding } from "@/features/my/onboarding";

export const Route = createFileRoute("/(member)/(protected)/my/onboarding")({
  component: Onboarding,
});
